<div class="my-row mdr-filters">

  <mat-form-field class="my-form-field-color mdr-filter-field" appearance="fill">
    <mat-label>Request Date</mat-label>
    <mat-date-range-input [formGroup]="filterDateRange" [rangePicker]="requestDatePicker">
      <input matStartDate formControlName="start" placeholder="Start date" />
      <input matEndDate formControlName="end" placeholder="End date" />
    </mat-date-range-input>
    <mat-datepicker-toggle matSuffix [for]="requestDatePicker"></mat-datepicker-toggle>
    <mat-date-range-picker #requestDatePicker></mat-date-range-picker>
  </mat-form-field>

  <mat-form-field class="my-form-field-color mdr-filter-field" appearance="fill">
    <mat-label>Cabin</mat-label>
    <input matInput [(ngModel)]="filterCabin" name="cabin" />
  </mat-form-field>

  <mat-form-field class="my-form-field-color mdr-filter-field" appearance="fill">
    <mat-label>Requesting Passenger</mat-label>
    <input matInput [(ngModel)]="filterPassengerName" name="passengerName" />
  </mat-form-field>

  <mat-form-field class="my-form-field-color mdr-filter-field" appearance="fill">
          <mat-label>Ship</mat-label>
          <mat-select [(ngModel)]="selectedShips" name="shipSelect" multiple [disabled]="availableShips.length === 1">
            @for (ship of availableShips; track ship.id_ship) {
              <mat-option [value]="ship">{{ ship.ship_name }}</mat-option>
            }
          </mat-select>
        </mat-form-field>

  <div class="mdr-filter-field mdr-search-btn">
    <button class="my-button confirm" mat-raised-button (click)="search()">
      Search
    </button>
  </div>

</div>

<div class="mdr-export-row">
  <button class="mdr-export-btn" mat-button disableRipple
          [disabled]="exporting"
          (click)="exportData()">
    @if (exporting) {
      <mat-spinner diameter="18" class="mdr-btn-spinner"></mat-spinner>
    } @else {
      <mat-icon>ios_share</mat-icon>
    }
    <span>Export</span>
  </button>
</div>

<div class="mat-elevation-z8 mdr-table-container"
     [class.mdr-table-container--first-load]="!store.firstLoadComplete()">
  <table mat-table
         [dataSource]="store.displayedItems()"
         [trackBy]="store.trackById">

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef>Actions</th>
      <td mat-cell *matCellDef="let row">
        <div class="mdr-actions-cell">
          <button class="mdr-action-btn mdr-accept" mat-raised-button
                  [disabled]="store.isRowPending(row.mdr_request_id)"
                  (click)="acceptRequest(row)">
            @if (store.isRowPending(row.mdr_request_id)) {
              <mat-spinner diameter="16" class="mdr-btn-spinner"></mat-spinner>
            } @else {
              <span>Accept</span>
            }
          </button>
          <button class="mdr-action-btn mdr-reject" mat-raised-button
                  [disabled]="store.isRowPending(row.mdr_request_id)"
                  (click)="rejectRequest(row)">
            @if (store.isRowPending(row.mdr_request_id)) {
              <mat-spinner diameter="16" class="mdr-btn-spinner"></mat-spinner>
            } @else {
              <span>Reject</span>
            }
          </button>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="request_datetime">
      <th mat-header-cell *matHeaderCellDef class="mdr-sortable-header" (click)="onSort('request_datetime')">
        Request date/time
        <span class="mdr-sort-icon">@if (sortBy === 'request_datetime') { {{ sortOrder === 'asc' ? '▲' : '▼' }} }</span>
      </th>
      <td mat-cell *matCellDef="let row">{{ row.request_datetime | date:'MM/dd/yyyy, hh:mm a':'UTC' }}</td>
    </ng-container>

    <ng-container matColumnDef="ship">
      <th mat-header-cell *matHeaderCellDef class="mdr-sortable-header" (click)="onSort('ship')">
        Ship
        <span class="mdr-sort-icon">@if (sortBy === 'ship') { {{ sortOrder === 'asc' ? '▲' : '▼' }} }</span>
      </th>
      <td mat-cell *matCellDef="let row">{{ row.ship_id }}</td>
    </ng-container>

    <ng-container matColumnDef="booking_number">
      <th mat-header-cell *matHeaderCellDef class="mdr-sortable-header" (click)="onSort('booking_number')">
        Booking Number
        <span class="mdr-sort-icon">@if (sortBy === 'booking_number') { {{ sortOrder === 'asc' ? '▲' : '▼' }} }</span>
      </th>
      <td mat-cell *matCellDef="let row">{{ row.booking_number }}</td>
    </ng-container>

    <ng-container matColumnDef="cabin">
      <th mat-header-cell *matHeaderCellDef class="mdr-sortable-header" (click)="onSort('cabin')">
        Cabin
        <span class="mdr-sort-icon">@if (sortBy === 'cabin') { {{ sortOrder === 'asc' ? '▲' : '▼' }} }</span>
      </th>
      <td mat-cell *matCellDef="let row">{{ row.cabin }}</td>
    </ng-container>

    <ng-container matColumnDef="passenger_name">
      <th mat-header-cell *matHeaderCellDef class="mdr-sortable-header" (click)="onSort('passenger_name')">
        Passenger Name
        <span class="mdr-sort-icon">@if (sortBy === 'passenger_name') { {{ sortOrder === 'asc' ? '▲' : '▼' }} }</span>
      </th>
      <td mat-cell *matCellDef="let row">{{ row.passenger_name }}</td>
    </ng-container>

    <ng-container matColumnDef="restaurant">
      <th mat-header-cell *matHeaderCellDef class="mdr-sortable-header" (click)="onSort('restaurant')">
        Restaurant
        <span class="mdr-sort-icon">@if (sortBy === 'restaurant') { {{ sortOrder === 'asc' ? '▲' : '▼' }} }</span>
      </th>
      <td mat-cell *matCellDef="let row">{{ row.restaurant }}</td>
    </ng-container>

    <ng-container matColumnDef="original_shift">
      <th mat-header-cell *matHeaderCellDef class="mdr-sortable-header" (click)="onSort('original_shift')">
        Original Time
        <span class="mdr-sort-icon">@if (sortBy === 'original_shift') { {{ sortOrder === 'asc' ? '▲' : '▼' }} }</span>
      </th>
      <td mat-cell *matCellDef="let row">{{ row.original_shift }}</td>
    </ng-container>

    <ng-container matColumnDef="requested_shift">
      <th mat-header-cell *matHeaderCellDef class="mdr-sortable-header" (click)="onSort('requested_shift')">
        Requested Time
        <span class="mdr-sort-icon">@if (sortBy === 'requested_shift') { {{ sortOrder === 'asc' ? '▲' : '▼' }} }</span>
      </th>
      <td mat-cell *matCellDef="let row">{{ row.requested_shift }}</td>
    </ng-container>

    <ng-container matColumnDef="total_diners">
      <th mat-header-cell *matHeaderCellDef class="mdr-sortable-header" (click)="onSort('total_diners')">
        Total Diners
        <span class="mdr-sort-icon">@if (sortBy === 'total_diners') { {{ sortOrder === 'asc' ? '▲' : '▼' }} }</span>
      </th>
      <td mat-cell *matCellDef="let row">
        <button class="mdr-diners-cell" mat-button disableRipple
                (click)="openPassengersModal(row)" title="View passengers">
          <span>{{ row.total_diners }}</span>
          <mat-icon>open_in_full</mat-icon>
        </button>
      </td>
    </ng-container>

    <ng-container matColumnDef="embark_date">
      <th mat-header-cell *matHeaderCellDef class="mdr-sortable-header" (click)="onSort('embark_date')">
        Embark Date
        <span class="mdr-sort-icon">@if (sortBy === 'embark_date') { {{ sortOrder === 'asc' ? '▲' : '▼' }} }</span>
      </th>
      <td mat-cell *matCellDef="let row">{{ row.embark_date | date:'MM/dd/yyyy':'UTC' }}</td>
    </ng-container>

    <ng-container matColumnDef="disembark_date">
      <th mat-header-cell *matHeaderCellDef class="mdr-sortable-header" (click)="onSort('disembark_date')">
        Disembark Date
        <span class="mdr-sort-icon">@if (sortBy === 'disembark_date') { {{ sortOrder === 'asc' ? '▲' : '▼' }} }</span>
      </th>
      <td mat-cell *matCellDef="let row">{{ row.disembark_date | date:'MM/dd/yyyy':'UTC' }}</td>
    </ng-container>

    <ng-container matColumnDef="language">
      <th mat-header-cell *matHeaderCellDef class="mdr-sortable-header" (click)="onSort('language')">
        Language
        <span class="mdr-sort-icon">@if (sortBy === 'language') { {{ sortOrder === 'asc' ? '▲' : '▼' }} }</span>
      </th>
      <td mat-cell *matCellDef="let row">{{ row.language }}</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"
        animate.enter="mdr-row-enter"
        animate.leave="mdr-row-leave"></tr>
    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell" [attr.colspan]="displayedColumns.length">
        No requests found.
      </td>
    </tr>

  </table>

  <mat-paginator
    [length]="store.totalItems()"
    [pageIndex]="store.currentPage() - 1"
    [pageSize]="store.pageSize()"
    [pageSizeOptions]="[10, 20, 50]"
    [disabled]="store.pendingActions().size > 0"
    showFirstLastButtons
    (page)="onPageChange($event)">
  </mat-paginator>
</div>
